function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  transform: "translate(2 2)",
  fillRule: "evenodd",
  d: "M10 0c5.43 0 9.848 4.325 9.996 9.72L20 10c0 5.43-4.325 9.848-9.72 9.996L10 20C4.57 20 .152 15.675.004 10.28L0 10C0 4.57 4.325.152 9.72.004L10 0zm0 1l-.252.003C4.893 1.137 1 5.113 1 10l.003.252C1.137 15.107 5.113 19 10 19l.252-.003C15.107 18.863 19 14.887 19 10l-.003-.252C18.863 4.893 14.887 1 10 1zm1.807 4.469v5.666h1.184v.885h-1.184V14h-1.09v-1.98H6.832v-.64l3.82-5.911h1.155zm-1.09 1.482l-.129.235-2.525 3.949h2.654V6.95z"
});
const SvgIconDevIcStepperFour = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconDevIcStepperFour, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-dev-ic-stepper-four.9b81e3e9.svg";
export { ForwardRef as ReactComponent };